import React, { useState } from "react";
import Navbar from '../Components/Navbar'

import rj from '../Assets/rj.png'
import s1 from '../Assets/final1.jpg'
import s2 from '../Assets/final4.png'
import s3 from '../Assets/service3.jpg'
import s4 from '../Assets/news4.jpg'
import s5 from '../Assets/final6.jpg'
import s6 from '../Assets/s6.png'
import s7 from '../Assets/final2.png'
import s8 from '../Assets/final5.png'
import s9 from '../Assets/final3.png'
import s10 from '../Assets/news10.jpg'
import s11 from '../Assets/final7.webp'
import s12 from '../Assets/news12.jpg'
import s13 from '../Assets/news13.jpg'
import s14 from '../Assets/news14.jpg'
import Footer from '../Components/Footer'
import { Helmet } from "react-helmet";



const treatments = [
  {
    title: "Ovulation Induction",
    desc: "Carefully monitored medication protocols to stimulate healthy egg production and regulate ovulation cycles.",
    img: s4,
  },
  {
    title: "Intrauterine Insemination (IUI)",
    desc: "A minimally invasive fertility treatment that enhances fertilization by placing prepared sperm directly into the uterus.",
    img: s1,
  },
  {
    title: "In Vitro Fertilization (IVF)",
    desc: "Advanced assisted reproductive technology where fertilization occurs outside the body to improve pregnancy success rates.",
    img: s2,
  },
  {
    title: "Intracytoplasmic Sperm Injection (ICSI)",
    desc: "A specialized IVF technique where a single healthy sperm is directly injected into an egg to improve the chances of successful fertilization.",
    img: s3,
  },
    {
    title: "Transvaginal Oocyte Retrieval",
    desc: "A safe, ultrasound-guided procedure to collect mature eggs as part of the IVF process.",
    img: s11,
  },
   {
    title: "Embryo Transfer",
    desc: "Precise transfer of selected healthy embryos into the uterus to maximize implantation and pregnancy outcomes.",
    img: s5,
  },
  {
    title: "Egg Freezing (Oocyte Cryopreservation)",
    desc: "Fertility preservation technique allowing women to store healthy eggs for future pregnancy planning.",
    img: s9,
  },
  {
    title: "Blastocyst Culture",
    desc: "Extended embryo development to the blastocyst stage before transfer to enhance implantation success.",
    img: s7,
  },
  {
    title: "Laser Assisted Hatching",
    desc: "An advanced IVF technique that improves embryo implantation by gently thinning the outer shell.",
    img: s8,
  },
  {
    title: "TESA / TESE / PESA",
    desc: "Advanced surgical sperm retrieval techniques used in male infertility cases for IVF/ICSI treatment.",
    img: s10,
  },
  {
    title: "Laparoscopy & Hysteroscopy",
    desc: "Minimally invasive procedures for diagnosing and treating infertility-related gynecological conditions.",
    img: s6,
  },
  {
    title: "Normal Vaginal Delivery",
    desc: "Comprehensive prenatal care and expert management of safe natural childbirth.",
    img: s12,
  },
  {
    title: "Cesarean Section (C-Section)",
    desc: "Safe and planned surgical delivery for medically indicated or high-risk pregnancies.",
    img: s13,
  },

  // Extra services 
 

  {
    title: "High-Risk Pregnancy Care",
    desc: "Specialized monitoring and management of complicated pregnancies to ensure healthy outcomes.",
    img: s14,
  },
];
function Services() {
  return (
    <>
    <Helmet>
  <title>IVF, IUI & Fertility Treatments in Delhi | Dr. Monika Gupta</title>

  <meta
    name="description"
    content="Get advanced fertility treatments in Delhi including IVF, IUI, ICSI, egg freezing & PCOS care by Dr. Monika Gupta. 15+ years experience, trusted IVF specialist."
  />

  <meta
    name="keywords"
    content="IVF treatment Delhi, IUI treatment Delhi, ICSI treatment Delhi, egg freezing Delhi, fertility clinic Delhi, infertility treatment Delhi, PCOS treatment Delhi, test tube baby Delhi, IVF specialist Delhi"
  />


  <meta property="og:title" content="IVF & Fertility Treatments in Delhi | Dr. Monika Gupta" />
  <meta property="og:description" content="Advanced IVF, IUI, ICSI & infertility treatments with high success rate in Delhi." />
  <meta property="og:type" content="website" />
</Helmet>
        <Navbar/>
        <div className='banner-page'>
        <h3>Fertility & IVF Services</h3>

        <p>Home-Services</p>

        </div>
 <section className="services">
        <div className="services-grid">
          {treatments.map((item, index) => (
            <div className="card" key={index}>
              <div className="card-img">
                <img src={item.img} alt={item.title} />
              </div>

              <h3>{item.title}</h3>
              <p>{item.desc}</p>

              <a href="/contact" className="link">
                Schedule a check-up <span>→</span>
              </a>
            </div>
          ))}
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default Services